import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const DownArrow: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.39937 15.157C2.39937 15.1169 2.40384 15.0763 2.41315 15.0355L3.45928 10.477C3.52604 10.186 3.81611 10.0042 4.1071 10.0709C4.39805 10.1377 4.57973 10.4276 4.51308 10.7188L3.46696 15.2773C3.4002 15.5683 3.11013 15.7501 2.81914 15.6834C2.56884 15.626 2.39937 15.4033 2.39937 15.157Z"
        fill="currentColor"
      />
      <path
        d="M2.39997 15.1563C2.39997 14.9097 2.56975 14.687 2.82039 14.6298L7.39169 13.5864C7.68276 13.52 7.97259 13.7021 8.03905 13.9932C8.10554 14.2843 7.92336 14.5741 7.63229 14.6405L3.061 15.6839C2.76993 15.7503 2.48009 15.5682 2.41364 15.2771C2.40437 15.2367 2.39997 15.1962 2.39997 15.1563Z"
        fill="currentColor"
      />
      <path
        d="M0.355469 0.540593C0.355469 0.242031 0.5975 0 0.896061 0C5.0092 0 8.35547 3.3377 8.35547 7.44033C8.35547 9.41716 7.58543 11.279 6.18719 12.6829L3.45511 15.4072C3.24366 15.618 2.90139 15.6175 2.69056 15.4062C2.47984 15.1947 2.48035 14.8524 2.69164 14.6416L5.42244 11.9186C6.61615 10.7201 7.27428 9.12922 7.27428 7.44033C7.27428 3.93389 4.413 1.08119 0.896061 1.08119C0.5975 1.08119 0.355469 0.839154 0.355469 0.540593Z"
        fill="currentColor"
      />
    </svg>
  )
})

DownArrow.displayName = 'DownArrow'
